import { AlertTriangle } from 'lucide-react';

export const GlobalErrorFallback = ({ error, componentStack }) => {
	const message = error?.message || String(error) || 'Unknown error';
	console.error(error);
	return (
		<div className="min-h-screen w-full flex items-center justify-center bg-[#15192d] p-4">
			<div className="max-w-md w-full text-center">
				<div className="flex justify-center mb-8">
					<div className="w-16 h-16 rounded-full bg-red-500/10 flex items-center justify-center border border-red-500/20">
						<AlertTriangle className="w-8 h-8 text-red-400" strokeWidth={1.5} />
					</div>
				</div>

				<h1 className="text-xl font-semibold text-white mb-3">Something went wrong</h1>
				<p className="text-[#9FA8C6] text-sm mb-4">
					We're working on fixing this. Please refresh the page to try again.
				</p>

				<div className="bg-red-500/10 border border-red-500/20 rounded-lg px-4 py-3 text-left mb-4">
					<p className="text-red-400 text-xs font-mono break-all">{message}</p>
				</div>

				{componentStack && (
					<details className="text-left">
						<summary className="text-[#9FA8C6] text-xs cursor-pointer hover:text-white transition-colors">
							Stack trace
						</summary>
						<pre className="mt-2 text-[10px] text-[#9FA8C6] font-mono overflow-auto max-h-48 bg-white/5 rounded p-2 whitespace-pre-wrap break-all">
							{componentStack}
						</pre>
					</details>
				)}
			</div>
		</div>
	);
};

export default GlobalErrorFallback;
